import React, { FunctionComponent } from 'react'

import Alerts from './Alerts'
import TableContext, {
  createTableContext,
} from '../../../contexts/TableContext'

export type AlertSorts = 'subject' | 'timeInserted' | 'timeSent'

export interface AlertFilters {
  subject?: string
}

export const AlertsTableContext = createTableContext<AlertFilters, AlertSorts>()

const AlertsContainer: FunctionComponent = () => {
  return (
    <TableContext<AlertFilters, AlertSorts>
      Context={AlertsTableContext}
      queryParams={['subject']}
      defaultFilters={{
        subject: '',
      }}
    >
      <Alerts />
    </TableContext>
  )
}

export default AlertsContainer
